export default __webpack_public_path__ + "static/media/follow-up-card-icon.a15a3352.svg";